/* Studiomoda – fotoslider in productkaarten.
   Alleen de eerste foto laadt direct; overige foto's laden bij doorbladeren, hover over een kleur of aanraken.
   Video's in de kaart spelen automatisch (gedempt) af zodra de kaart in beeld is en de video-slide actief is. */
(function () {
  // Collectiepagina's: ronde kleurknoppen laden (apart bestand sm-colorfilter.js in dezelfde map)
  var SM_CF_VERSION = '25';
  var me = document.currentScript;
  if (me && me.src && /\/collections\//.test(location.pathname) && !window.smColorFilterLoading) {
    window.smColorFilterLoading = true;
    var cf = document.createElement('script');
    cf.src = me.src.replace('sm-card-swiper.js', 'sm-colorfilter.js') + (me.src.indexOf('?') > -1 ? '&' : '?') + 'cf=' + SM_CF_VERSION;
    cf.defer = true;
    document.head.appendChild(cf);
  }

  if (window.smCardSwiperInit) return;
  window.smCardSwiperInit = true;

  // Minimalistische pijltjes in de productkaarten: klein halfdoorzichtig rondje met een dun donker pijltje
  if (!document.getElementById('sm-card-arrows-css')) {
    var css = document.createElement('style');
    css.id = 'sm-card-arrows-css';
    css.textContent =
      '.product-card__figure .swiper-button-next,.product-card__figure .swiper-button-prev{' +
      'width:30px!important;height:30px!important;margin-top:-15px!important;padding:0!important;' +
      'background:rgba(255,255,255,.72)!important;box-shadow:none!important;border:0!important;border-radius:50%!important;' +
      '-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);color:#272727!important;' +
      'align-items:center;justify-content:center;transition:background .2s,opacity .2s}' +
      '.product-card__figure .swiper-button-next:hover,.product-card__figure .swiper-button-prev:hover{background:rgba(255,255,255,.95)!important}' +
      '.product-card__figure .swiper-button-next::after,.product-card__figure .swiper-button-prev::after{' +
      'content:""!important;font-size:0!important;width:7px;height:7px;border-top:1.5px solid currentColor;border-right:1.5px solid currentColor}' +
      '.product-card__figure .swiper-button-next::after{transform:rotate(45deg);margin-left:-3px}' +
      '.product-card__figure .swiper-button-prev::after{transform:rotate(-135deg);margin-left:3px}' +
      '.product-card__figure .swiper-button-disabled{opacity:0!important;pointer-events:none}' +
      // Geen rode "Bespaar"/"Aanbieding"-labels op productkaarten; de doorgestreepte prijs staat onder de kaart
      '.product-card__badge-list on-sale-badge{display:none!important}' +
      '.product-card video.sm-card-video{width:100%;height:100%;object-fit:cover;display:block}' +
      '.product-card__swiper img,.product-card__swiper a{-webkit-user-drag:none;user-select:none;-webkit-user-select:none}';
    document.head.appendChild(css);
  }

  function loadSlide(slide) {
    if (!slide) return;
    slide.querySelectorAll('img[data-src]').forEach(function (img) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }

  // ---- Video's in productkaarten ----
  // De kaart toont een video als preview-afbeelding (/preview_images/<id>.thumbnail...). De videobron komt uit
  // /products/<handle>.js; de video wordt gekoppeld via dat preview-id (niet via de positie), zodat een verouderde
  // cache nooit een verkeerde video in een slide zet.
  var productJs = {};
  function getProduct(handle, fresh) {
    var key = handle + (fresh ? '#fresh' : '');
    if (!productJs[key]) {
      productJs[key] = fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + encodeURIComponent(handle) + '.js' + (fresh ? '?_=' + Date.now() : ''))
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productJs[key];
  }
  function previewId(url) {
    var m = /\/preview_images\/([0-9a-f]+)/i.exec(url || '');
    return m ? m[1] : null;
  }
  function pickSource(sources) {
    var mp4 = (sources || []).filter(function (s) { return s.format === 'mp4' || /mp4/.test(s.mime_type || ''); });
    if (!mp4.length) return null;
    mp4.sort(function (a, b) { return Math.abs((a.height || 0) - 720) - Math.abs((b.height || 0) - 720); });
    return mp4[0];
  }
  function activeSlide(v) {
    var s = v.closest('.swiper-slide'), sw = v.closest('.product-card__swiper');
    if (!s) return true;
    if (!sw || !sw.swiper) return s === s.parentElement.firstElementChild;
    return sw.swiper.slides[sw.swiper.activeIndex] === s;
  }
  function syncVideo(v) {
    if (v._smInView && activeSlide(v)) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    } else if (!v.paused) {
      v.pause();
    }
  }
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target._smInView = e.isIntersecting; syncVideo(e.target); });
  }, { threshold: 0.5 }) : null;
  function watchVideo(v) {
    v.muted = true;
    if (vio) vio.observe(v); else { v._smInView = true; syncVideo(v); }
  }
  function initCardVideos(card) {
    if (card.hasAttribute('data-sm-video')) return;
    card.setAttribute('data-sm-video', '');
    var swiperEl = card.querySelector('.product-card__swiper');
    var handle = card.getAttribute('handle');
    if (!swiperEl || !handle) return;
    var targets = [];
    swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide img').forEach(function (img) {
      var id = previewId(img.getAttribute('data-src') || img.getAttribute('src'));
      if (id) targets.push({ img: img, id: id });
    });
    if (!targets.length) return;

    function apply(product) {
      var byId = {};
      ((product && product.media) || []).forEach(function (m) {
        var id = m.media_type === 'video' && m.preview_image && previewId(m.preview_image.src);
        if (id) byId[id] = m;
      });
      var missing = false;
      targets.forEach(function (t) {
        if (t.done) return;
        var media = byId[t.id];
        if (!media) { missing = true; return; }
        var src = pickSource(media.sources);
        if (!src) return;
        t.done = true;
        var img = t.img;
        var v = document.createElement('video');
        v.className = (img.className || '') + ' sm-card-video';
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('preload', 'none');
        if (media.preview_image && media.preview_image.src) v.poster = media.preview_image.src + (media.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=600';
        if (img.alt) v.setAttribute('aria-label', img.alt);
        var source = document.createElement('source');
        source.src = src.url;
        source.type = src.mime_type || 'video/mp4';
        v.appendChild(source);
        img.replaceWith(v);
        watchVideo(v);
      });
      return missing;
    }

    getProduct(handle).then(function (product) {
      // Productdata nog niet bijgewerkt (net geüploade video)? Eén keer vers ophalen.
      if (apply(product)) getProduct(handle, true).then(apply);
    });
  }

  function initCard(el) {
    if (el.swiper || typeof Swiper === 'undefined') return;

    var container = el.closest('.product-card__figure') || el;
    // Desktop: foto's slepen met de muis en horizontaal vegen met de trackpad (verticaal scrollen blijft de pagina scrollen)
    el.querySelectorAll('img, a').forEach(function (n) { n.setAttribute('draggable', 'false'); });
    var swiper = new Swiper(el, {
      slidesPerView: 1,
      grabCursor: true,
      mousewheel: { forceToAxis: true, thresholdDelta: 10, releaseOnEdges: true },
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
        type: 'bullets',
        dynamicBullets: false
      },
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev')
      },
      on: {
        slideChange: function () {
          // Huidige en volgende foto laden, zodat doorbladeren soepel blijft
          loadSlide(this.slides[this.activeIndex]);
          loadSlide(this.slides[this.activeIndex + 1]);
          if (this.pagination && this.pagination.update) this.pagination.update();
          // Video's: alleen de actieve slide speelt af
          this.el.querySelectorAll('video.sm-card-video').forEach(syncVideo);
        },
        touchEnd: function () {
          if (this.pagination && this.pagination.update) this.pagination.update();
        }
      }
    });
    el.swiper = swiper;

    // Bij eerste interactie met de kaart alvast de tweede foto laden
    var card = el.closest('.product-card');
    if (card) {
      var warm = function () { loadSlide(swiper.slides[1]); };
      card.addEventListener('pointerenter', warm, { once: true });
      card.addEventListener('touchstart', warm, { once: true, passive: true });
    }
  }

  function initAll() {
    document.querySelectorAll('.product-card__swiper').forEach(initCard);
    document.querySelectorAll('product-card[handle]').forEach(initCardVideos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Kaarten die later worden toegevoegd (filters, 'meer laden') – max. 1x per frame controleren
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; initAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Kleur-swatch (hover, klik of tik) -> naar de foto van die kleur.
  // Het kleurfilter (sm-colorfilter.js) zet op de eerste foto een studiofoto van de standaardkleur. Hoort de gekozen
  // kleur bij de eerste foto maar is die studiofoto een andere kleur, dan komt de eigen eerste productfoto terug.
  var COLOR_KEYS = [
    { key: 'light', re: /light natural|light oak|oak light|licht|naturel eiken/i },
    { key: 'brown', re: /brown|bruin|chocolate/i },
    { key: 'walnut', re: /walnut|walnoot/i },
    { key: 'black', re: /black|zwart/i }
  ];
  function colorKey(text) {
    for (var i = 0; i < COLOR_KEYS.length; i++) if (COLOR_KEYS[i].re.test(text || '')) return COLOR_KEYS[i].key;
    return null;
  }
  // Kaartlink naar de variant van de gekozen kleur
  function linkToColor(card, value) {
    var handle = card.getAttribute('handle');
    if (!handle || !value) return;
    getProduct(handle).then(function (product) {
      if (!product || !product.options) return;
      var idx = -1;
      product.options.forEach(function (o, i) { if (/^(kleur|colou?r)$/i.test(o.name || o)) idx = i; });
      if (idx < 0) return;
      var variant = (product.variants || []).filter(function (v) { return v.options[idx] === value; })[0];
      if (!variant) return;
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        if (!a.dataset.smHref) a.dataset.smHref = a.getAttribute('href');
        var href = a.dataset.smHref.split('?')[0] + '?variant=' + variant.id;
        if (a.getAttribute('href') !== href) a.setAttribute('href', href);
      });
    });
  }
  function showSwatch(swatch) {
    var card = swatch.closest('.product-card');
    var swiperEl = card && card.querySelector('.product-card__swiper');
    if (!swiperEl || !swiperEl.swiper) return;
    var sw = swiperEl.swiper;
    var label = swatch.querySelector('.sr-only');
    var value = (label ? label.textContent : swatch.textContent).trim();
    var key = colorKey(value);

    // Collectiepagina: de studiofoto's van het kleurfilter bovenaan zijn leidend
    if (key && window.smStudio && window.smStudio.has(card, key)) {
      card.dataset.smCf = 'swatch'; // het kleurfilter zet dan niet de standaardkleur terug
      window.smStudio.set(card, key);
      loadSlide(sw.slides[0]);
      if (sw.activeIndex !== 0) sw.slideTo(0);
      linkToColor(card, value);
      return;
    }

    // Geen studiofoto voor deze kleur (of geen collectiepagina): de productfoto van de variant
    var index = parseInt(swatch.getAttribute('data-slide-index'), 10);
    if (isNaN(index)) return;
    loadSlide(sw.slides[index]);
    if (sw.activeIndex !== index) sw.slideTo(index);
    linkToColor(card, value);
    if (index !== 0) return;

    var img = sw.slides[0] && sw.slides[0].querySelector('img');
    var studio = img && img.dataset.smStudio;
    if (!studio || !key || key === studio) return;
    var handle = card.getAttribute('handle');
    if (!handle) return;
    card.dataset.smCf = card.dataset.smCf || 'swatch'; // voorkomt dat het kleurfilter de studiofoto terugzet
    getProduct(handle).then(function (product) {
      var m = product && product.media && product.media[0];
      var src = m && ((m.preview_image && m.preview_image.src) || m.src);
      if (!src) return;
      img.removeAttribute('srcset');
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800';
      delete img.dataset.smStudio;
    });
  }
  function swatchFrom(e) {
    return e.target && e.target.closest ? e.target.closest('.color-swatch[data-slide-index], .media-swatch[data-slide-index]') : null;
  }
  document.addEventListener('mouseenter', function (e) {
    var swatch = swatchFrom(e);
    if (swatch) showSwatch(swatch);
  }, true);
  document.addEventListener('click', function (e) {
    var swatch = swatchFrom(e);
    if (swatch) showSwatch(swatch);
  }, true);
})();

/* Studiomoda (smSwatchBackToFirst): bij een klik op een houtkleur (swatch-app) de kaart terugzetten
   naar de eerste foto. De swatch-app wisselt namelijk alleen de eerste foto; stond de klant al op
   foto 2 of verder, dan leek de klik niets te doen. */
(function () {
  if (window.smSwatchBackToFirst) return;
  window.smSwatchBackToFirst = true;
  function backToFirst(e) {
    var el = e.target && e.target.closest ? e.target.closest('.swatch-view-item, .swatch-selector, .swatch-custom-image') : null;
    if (!el) return;
    var card = el.closest('product-card, .product-card');
    if (!card) return;
    var swEl = card.querySelector('.product-card__swiper');
    var sw = swEl && swEl.swiper;
    if (!sw || sw.activeIndex === 0) return;
    sw.slideTo(0, 250);
  }
  document.addEventListener('click', backToFirst, true);
  document.addEventListener('mouseenter', function (e) {
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) backToFirst(e);
  }, true);
})();
